import React from 'react';
import { useMetaPixel } from './hooks/useMetaPixel';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { Problem } from './components/sections/Problem';
import { Different } from './components/sections/Different';
import { Steps } from './components/sections/Steps';
import { Imagine } from './components/sections/Imagine';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { PainPoints } from './components/sections/PainPoints';
import { Volumes } from './components/sections/Volumes';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { About } from './components/sections/About';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
export function App() {
  useMetaPixel();
  return <main className="w-full overflow-x-hidden bg-cream pb-24" data-id="element-0" data-mp="3ii4q3wgi0ilx">
      <Hero data-id="element-1" data-mp="3mjzrt22ccy08" />
      <Problem data-id="element-2" data-mp="3mjpyb4i388ps" />
      <Different data-id="element-3" data-mp="3mj6j3vjtnyfg" />
      <Steps data-id="element-4" data-mp="3rcj8i7wbs999" />
      <Imagine data-id="element-5" data-mp="3rbzmaezn6ypf" />
      <BeforeAfter data-id="element-6" data-mp="3rdki07xp0nov" />
      <PainPoints data-id="element-7" data-mp="3rd1all5o5hp3" />
      <Volumes data-id="element-8" data-mp="3relu8fqg3g86" />
      <Bonuses data-id="element-9" data-mp="5ot150vj28n" />
      <Offer data-id="element-10" data-mp="6htjo98ovic" />
      <Guarantee data-id="element-11" data-mp="4wx1t3d72hu" />
      <Testimonials data-id="element-12" data-mp="5gg5d4r3wxg" />
      <About data-id="element-13" data-mp="82ovg3doih9" />
      <FAQ data-id="element-14" data-mp="2zl3bdjx5744s" />
      <FinalCTA data-id="element-15" data-mp="2zld4hgdhhrep" />
      <FloatingCTA triggerId="hero-cta" data-id="element-16" data-mp="2zlv8iz6e19x6" />
      <PurchasePopup data-id="element-17" data-mp="2zn69yscd25l4" />
    </main>;
}